/**
 * Product-page INCI pill links → /pages/ingredients?i={slug}
 * Slug rules match PCE execution/glossary_slug.py (stored glossary_slug).
 *
 * Pill labels stay English INCI on every locale.
 * If Translate & Adapt still serves Chinese metafield text, restore English
 * from /products/{handle}?view=inci (default locale, no /zh prefix).
 * ingredient-zh-labels.json is used only to resolve glossary slugs — never as visible text.
 * Chinese encyclopedia names belong in the Ingredient Directory popup.
 */
(function () {
  var OCR_MARKERS_RE = /[*°†‡®™]+/g;
  var NON_SLUG_RE = /[^a-z0-9-]/g;
  var PERCENT_RE = /(\d+(?:\.\d+)?)\s*%\s*/g;
  var CJK_RE = /[\u4e00-\u9fff]/;

  function inciNameToSlug(inciName) {
    if (!inciName) return '';

    var s = inciName.trim().normalize('NFKD').replace(/\p{M}/gu, '');
    s = s.replace(OCR_MARKERS_RE, '');
    s = s.toLowerCase();

    s = s.replace(PERCENT_RE, '$1-pct-');
    s = s.replace(/%/g, '-pct');
    s = s.replace(/,/g, '-');

    var chars = '()/.:;';
    for (var i = 0; i < chars.length; i++) {
      s = s.split(chars.charAt(i)).join('-');
    }
    s = s.replace(/ /g, '-');

    s = s.replace(NON_SLUG_RE, '');
    s = s.replace(/-+/g, '-').replace(/^-|-$/g, '');
    return s;
  }

  function glossaryHref(baseUrl, slug) {
    var base = (baseUrl || '/pages/ingredients').replace(/\/$/, '');
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    return base + sep + 'i=' + encodeURIComponent(slug);
  }

  function resolveGlossaryMatch(name, slug, labels) {
    var empty = { slug: slug || '' };
    if (!labels) return empty;

    function hit(key) {
      if (key && labels[key]) return { slug: key };
      return null;
    }

    var found = hit(slug);
    if (found) return found;

    var withoutParen = String(name || '').replace(/\s*\([^)]*\)\s*/g, ' ').trim();
    found = hit(inciNameToSlug(withoutParen));
    if (found) return found;

    var match = String(name || '').match(/^(.+?)\s*\(([^)]+)\)\s*$/);
    if (match) {
      var firstAlias = match[2].split('/')[0].trim();
      found = hit(inciNameToSlug(match[1].trim() + ' (' + firstAlias + ')'));
      if (found) return found;
      found = hit(inciNameToSlug(firstAlias));
      if (found) return found;
    }

    if (slug) {
      var keys = Object.keys(labels);
      var prefixHits = keys.filter(function (key) {
        return slug === key || slug.indexOf(key + '-') === 0;
      });
      if (prefixHits.length) {
        prefixHits.sort(function (a, b) {
          return b.length - a.length;
        });
        return hit(prefixHits[0]) || empty;
      }
    }

    return empty;
  }

  function wireIngredientLinks(labels) {
    labels = labels || {};

    document.querySelectorAll('[data-bb-ing-name]').forEach(function (el) {
      var name = el.getAttribute('data-bb-ing-name');
      if (!name) return;

      var slug = inciNameToSlug(name);
      var parenSlash = name.match(/^(.+?)\s*\(([^)]*\/[^)]*)\)\s*$/);
      if (parenSlash) {
        var narrowed = inciNameToSlug(
          parenSlash[1].trim() + ' (' + parenSlash[2].split('/')[0].trim() + ')'
        );
        if (narrowed) slug = narrowed;
      }
      var pillsRoot = el.closest('[data-bb-ing-pills]');
      var glossaryUrl =
        (pillsRoot && pillsRoot.getAttribute('data-bb-ing-glossary-url')) ||
        '/pages/ingredients';
      var match = resolveGlossaryMatch(name, slug, labels);
      var hrefSlug = match.slug || slug;

      if (hrefSlug) {
        el.setAttribute('href', glossaryHref(glossaryUrl, hrefSlug));
      }

      if (typeof formatInciDisplayName === 'function' && el.textContent === name) {
        el.textContent = formatInciDisplayName(name);
      }
    });
  }

  function pillsNeedEnglishRestore(pillsRoot) {
    var nodes = pillsRoot.querySelectorAll('[data-bb-ing-name]');
    for (var i = 0; i < nodes.length; i++) {
      if (CJK_RE.test(nodes[i].getAttribute('data-bb-ing-name') || '')) return true;
    }
    return false;
  }

  function restoreEnglishPills(pillsRoot) {
    var url = pillsRoot.getAttribute('data-bb-ing-en-url');
    if (!url || !pillsNeedEnglishRestore(pillsRoot)) {
      return Promise.resolve();
    }

    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('[data-bb-ing-pills]');
        if (!src || !src.innerHTML) return;
        if (CJK_RE.test(src.textContent || '')) return;
        pillsRoot.innerHTML = src.innerHTML;
      })
      .catch(function () {
        /* Keep translated pills if the English view is unavailable. */
      });
  }

  function loadLabels(pillsRoot) {
    var labelsUrl = pillsRoot && pillsRoot.getAttribute('data-bb-ing-labels-url');
    if (!labelsUrl) return Promise.resolve({});
    return fetch(labelsUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .catch(function () {
        return {};
      });
  }

  function init() {
    var roots = document.querySelectorAll('[data-bb-ing-pills]');
    if (!roots.length) return;

    var restores = [];
    roots.forEach(function (root) {
      restores.push(restoreEnglishPills(root));
    });

    Promise.all([loadLabels(roots[0])].concat(restores)).then(function (results) {
      wireIngredientLinks(results[0] || {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
